import { useState } from "react";
import MessagesReactModal from "../components/templates/messages-react-modalV2";

export function useModalError() {
  const [isModaError, setIsModalError] = useState<boolean>(false);

  return {
    isModaError,
    setIsModalError,
    modaComponente: (
      <MessagesReactModal
        show={isModaError}
        onHide={()=> setIsModalError(!isModaError)}
        textTitle={"¡Ups lo sentimos!"}
        listButtonsModal={[
          {
            text: "Reintentar",
            spinner: false,
            onClick: () => {
              setIsModalError(!isModaError);
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            },
          },
        ]}
        onClickClose={()=> setIsModalError(!isModaError)}
        listParagraphs={[
          {
            textParagraph:
              "La aplicación no esta respondiendo debido a que hay problemas con la comunicación de nuestros sistemas.",
          },
          {
            textParagraph: "Vuelve a intentar si el error persiste.",
          },
        ]}
      />
    ),
  };
}
